import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Spin } from "antd";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  title: string;
  heading: string;
  paragraph?: string | JSX.Element;
  btnText: string;
  btnApi: () => void;
  loading: boolean;
  secondBtnText?: string;
  isArchivePopup?: boolean;
}

const PreferredVisitPopup = (props: PropsType) => {
  const { onClose, btnApi, loading } = props;

  const onCloseHandler = () => {
    onClose();
  };

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper ">
        <div className="modal_header">
          <div className="title">
            <h3> Adjust preferred visit time </h3>
            <p>
              Set customer-preferred days and times to schedule visits that
              align with customer availability.
            </p>
          </div>
        </div>

        <div className="modal_content">
          <p> ------ </p>
        </div>

        <div className="modal_footer">
          <Button
            htmlType="button"
            className="outlined-btn"
            type="default"
            size="large"
            onClick={onCloseHandler}
          >
            Cancel
          </Button>

          <Button
            htmlType="button"
            className="mint-btn"
            type="primary"
            size="large"
            onClick={btnApi}
            loading={loading}
          >
            Save
          </Button>
        </div>
      </div>
    </Spin>
  );
};

export default PreferredVisitPopup;
